<template>
    <div class="no-collapse">
        <div class="row" v-if="propertyAvailable('dropzone') === 'alternative_content'">
            <div class="col-md-12 flex-dropzone">
                <div v-if="propertyAvailable('name')">
                    <v-text-field
                        v-model="active_text_fields.name"
                        :label="t_name"
                        :disabled="element_readonly('name')"
                        @change="$emit('nameUpdated')"
                        :rules="[rules.required]"
                        :outlined="outlined" :dense="dense" hide-details="auto"
                        v-on:keydown="changedTextField('name')"
                        v-on:blur="updateTextField('name')">>
                    </v-text-field>
                </div>
                <div v-if="!element_readonly('dropzone')">
                    <div class="dropzone-description">
                        {{ dropzone_alternative_description }}
                    </div>
                    <div >
                        <div data-type="picture|video|pdf|ppt|template|campaign" class="alternative-dropzone"
                             :style="alternativeDropzoneStyles">
                            <div class="info" v-if="alternativeContentSet">{{ alternativeDropzoneInfo }}</div>
                            <v-btn v-if="alternativeContentSet"
                                    class="btn btn-primary btn-sm reset-alternative pull-right"
                                    @click.stop.prevent="resetAlternativeContent()">
                                <i class="fa-regular fa-trash fa-lg" aria-hidden="true"></i>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('text_input')">
            <div class="col-md-12">
                <v-textarea
                    v-model="active_text_fields.text_input" rows="4"
                    :label="t_text"
                    :class="[inner_properties.text_animation_type === 'newsticker' ? 'newsticker' : '']"
                    :disabled="element_readonly('text_input')"
                    :dir="inner_properties.text_direction"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('text_input')"
                    v-on:blur="updateTextField('text_input')">
                </v-textarea>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('url')">
            <div class="col-md-12">
                <v-text-field
                    v-model="active_text_fields.url"
                    :label="t_url"
                    :disabled="element_readonly('url')"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('url')"
                    v-on:blur="updateTextField('url')">
                </v-text-field>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('iframe_url')">
            <div class="col-md-12">
                <v-text-field
                    v-model="active_text_fields.iframe_url"
                    :label="t_url"
                    :disabled="element_readonly('iframe_url')"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('iframe_url')"
                    v-on:blur="updateTextField('iframe_url')">
                </v-text-field>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('iframe_user')">
            <div class="col-md-12">
                <v-text-field
                    v-model="active_text_fields.iframe_user"
                    :label="t_user"
                    :disabled="element_readonly('iframe_user')"
                    :hint="t_iframe_user_explanation"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    :autocomplete="'one-time-code'"
                    v-on:keydown="changedTextField('iframe_user')"
                    v-on:blur="updateTextField('iframe_user')">
                </v-text-field>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('iframe_pass')">
            <div class="col-md-12">
                <v-text-field
                    v-model="active_text_fields.iframe_pass"
                    :label="t_pass"
                    :disabled="element_readonly('iframe_pass')"
                    :hint="t_iframe_user_explanation"
                    :append-icon="show.iframe_pass ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show.iframe_pass ? 'text' : 'password'"
                    @click:append="show.iframe_pass = !show.iframe_pass"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    :autocomplete="'one-time-code'"
                    v-on:keydown="changedTextField('iframe_pass')"
                    v-on:blur="updateTextField('iframe_pass')">
                </v-text-field>
            </div>
        </div>
        <div class="row">
            <div id="select-iframe_transparent" class="col-md-6" v-if="propertyAvailable('iframe_transparent')">
                <v-select
                    v-model="inner_properties.iframe_transparent"
                    :label="t_transparent"
                    :disabled="element_readonly('iframe_transparent')"
                    :items="[
                        {value: '1', text: this.t_yes},
                        {value: '0', text: this.t_no}
                    ]"
                    attach="#select-iframe_transparent .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
            <div class="col-md-6 flex" v-if="propertyAvailable('show_scrollbars')"
                 style="display: flex; align-items: center;">
                <Checkbox
                    class="mr-2"
                    :binary="true"
                    :modelValue="inner_properties.show_scrollbars"
                    :label="t_show_scrollbars"
                    :disabled="element_readonly('show_scrollbars')"
                    @click="inner_properties.show_scrollbars = !inner_properties.show_scrollbars"
                />
                {{ t_show_scrollbars }}
            </div>
        </div>
        <v-row v-if="propertyAvailable('iframe_dropzone') && !element_readonly('iframe_dropzone')">
            <v-col class="col-md-12">
                <url-linked-files-field
                    v-model="inner_properties.linked_files"
                    @click="(file, index) => removeAttachedFile(file, index)"
                />
            </v-col>
        </v-row>
        <div class="row" v-if="propertyAvailable('loading_behavior')">
            <div id="select-loading_behavior" class="col-md-12">
                <v-select
                    v-model="inner_properties.loading_behavior"
                    :label="t_loading_behavior"
                    :disabled="element_readonly('loading_behavior')"
                    :items="[
                        {value: 'load', text: t_wait_for_load},
                        {value: 'partial', text: t_show_partial},
                        {value: 'event', text: t_wait_for_event}
                    ]"
                    attach="#select-loading_behavior .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('iframe_no_cache')">
            <div class="col-md-12">
                <Checkbox
                    class="mr-2"
                    :binary="true"
                    :modelValue="inner_properties.iframe_no_cache"
                    :label="t_no_cache"
                    :disabled="element_readonly('iframe_no_cache')"
                    @click="inner_properties.iframe_no_cache = !inner_properties.iframe_no_cache"
                />
                {{ t_no_cache }}
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('youtube_url')">
            <div class="col-md-12">
                <v-text-field
                    v-model="active_text_fields.youtube_url"
                    :label="t_url"
                    :disabled="element_readonly('youtube_url')"
                    :hint="t_youtube_playlist_explanation"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('youtube_url')"
                    v-on:blur="updateTextField('youtube_url')">
                </v-text-field>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('countdown_date')">
            <div class="col-md-12">
                <datepicker
                    v-model="inner_properties.countdown_date"
                    :disabled="element_readonly('countdown_date')"
                    :label="t_date">
                </datepicker>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('countdown_time')">
            <div class="col-md-12">
                <timepicker
                    :id="'countdown_time-' + inner_properties['index']"
                    :label="t_time"
                    v-model="inner_properties.countdown_time"
                    use-seconds
                    :disabled="element_readonly('countdown_time')">
                </timepicker>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('qrcode_url')">
            <div class="col-md-12">
                <v-text-field
                    v-model="active_text_fields.qrcode_url"
                    :label="t_url"
                    :disabled="element_readonly('qrcode_url')"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('qrcode_url')"
                    v-on:blur="updateTextField('qrcode_url')">
                </v-text-field>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('renderer')">
            <div id="select-renderer" class="col-md-12">
                <v-select
                    v-model="inner_properties.renderer"
                    :label="t_renderer"
                    :disabled="element_readonly('renderer')"
                    :items="[
                        {value: 'windows-media-streaming', text: t_windows_media_streaming},
                        {value: 'quicktime', text: t_quicktime}
                    ]"
                    attach="#select-renderer .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('primary_color')">
            <div class="col-md-12">
                <colorpicker
                    :id="'primary_color-' + inner_properties['index']"
                    :label="inner_properties.type === 'emptyrectangle' ? t_rectanglecolor : t_backgroundcolor"
                    v-model="inner_properties.primary_color"
                    :disabled="element_readonly('primary_color')">
                </colorpicker>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('layer')">
            <div id="select-layer" class="col-md-12">
                <v-autocomplete v-model="inner_properties.layer"
                                :label="t_layer"
                                :disabled="element_readonly('layer')"
                                :items="selectableLayers"
                                :placeholder="t_select"
                                persistent-placeholder
                                attach="#select-layer .v-select"
                                :outlined="outlined" :dense="dense" hide-details="auto">
                </v-autocomplete>
            </div>
        </div>

        <template v-if="inner_properties.type === 'esign'">
            <div class="alert alert-info" v-if="esign_check === true">
                <i class="fa-regular fa-spinner fa-spin-pulse m-r-sm"></i>
                {{ t_esign_check }}
            </div>
            <template v-else>
                <div class="row">
                    <div id="select-esign_type" class="col-md-12" v-if="propertyAvailable('esign_type')">
                        <v-select v-model="inner_properties.esign_type"
                                  :label="t_esign_type"
                                  :disabled="element_readonly('esign_type')"
                                  :items="[
                                      {value: 'stBoard', text: t_esign_board},
                                      {value: 'stDoorSign', text: t_esign_doorsign}
                                  ]"
                                  attach="#select-esign_type .v-select"
                                  :outlined="outlined" :dense="dense" hide-details="auto">
                        </v-select>
                    </div>
                </div>
                <template v-if="esign_manually === true">
                    <div class="row">
                        <div class="col-md-3" v-if="propertyAvailable('esign_id')">
                            <v-text-field
                                v-model="active_text_fields.esign_id"
                                :label="t_esign_id"
                                :disabled="element_readonly('esign_id')"
                                :outlined="outlined" :dense="dense" hide-details="auto"
                                v-on:keydown="changedTextField('esign_id')"
                                v-on:blur="updateTextField('esign_id')">
                            </v-text-field>
                        </div>
                        <div class="col-md-9" v-if="propertyAvailable('esign_name')">
                            <v-text-field
                                v-model="active_text_fields.esign_name"
                                :label="t_esign_name"
                                :disabled="element_readonly('esign_name')"
                                :outlined="outlined" :dense="dense" hide-details="auto"
                                v-on:keydown="changedTextField('esign_name')"
                                v-on:blur="updateTextField('esign_name')">
                            </v-text-field>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="row" v-if="propertyAvailable('esign_id')">
                        <div id="select-esign_id" class="col-md-12">
                            <v-select v-model="inner_properties.esign_id"
                                      @change="updateEsignName(inner_properties.esign_type === 'stBoard' ? 'boards' : 'doorsigns')"
                                      :label="t_esign_name"
                                      :disabled="element_readonly('esign_id')"
                                      :items="inner_properties.esign_type === 'stBoard' ? esign.boards : esign.doorsigns"
                                      item-value="id" item-text="name"
                                      attach="#select-esign_id .v-select"
                                      :outlined="outlined" :dense="dense" hide-details="auto">
                            </v-select>
                        </div>
                    </div>
                    <div class="row" v-if="propertyAvailable('esign_style')">
                        <div id="select-esign_style" class="col-md-12">
                            <v-select v-model="inner_properties.esign_style"
                                      :label="t_esign_style"
                                      :disabled="element_readonly('esign_style')"
                                      :items="inner_properties.esign_type === 'stBoard' ? esign.board_styles : esign.doorsign_styles"
                                      item-value="id" item-text="name"
                                      attach="#select-esign_style .v-select"
                                      :outlined="outlined" :dense="dense" hide-details="auto">
                            </v-select>
                        </div>
                    </div>
                </template>
                <div class="row">
                    <div class="col-md-3" v-if="esign_manually && propertyAvailable('esign_style')">
                        <v-text-field
                            v-model="active_text_fields.esign_style"
                            :label="t_esign_style_id"
                            :disabled="element_readonly('esign_style')"
                            :outlined="outlined" :dense="dense" hide-details="auto"
                            v-on:keydown="changedTextField('esign_style')"
                            v-on:blur="updateTextField('esign_style')">
                        </v-text-field>
                    </div>
                    <div :class="esign_manually ? 'col-md-5' : 'col-md-6'" v-if="propertyAvailable('esign_refresh')">
                        <number-field
                            v-model="inner_properties.esign_refresh"
                            :label="t_esign_refresh"
                            :hint="t_esign_refresh_description"
                            :disabled="element_readonly('esign_refresh')"
                            :limits="getFieldEvaluatedLimits('esign_refresh')"
                            :outlined="outlined" :dense="dense" hide-details="auto">
                        </number-field>
                    </div>
                    <div id="select-esign_transparency" :class="esign_manually ? 'col-md-4' : 'col-md-6'" v-if="propertyAvailable('esign_transparency')">
                        <v-select v-model="inner_properties.esign_transparency"
                                  :label="t_esign_transparency"
                                  :disabled="element_readonly('esign_transparency')"
                                  :items="[
                                          {value: '1', text: this.t_yes},
                                          {value: '0', text: this.t_no}
                                      ]"
                                  attach="#select-esign_transparency .v-select"
                                  :outlined="outlined" :dense="dense" hide-details="auto">
                        </v-select>
                    </div>
                </div>
                <div class="row" v-if="inner_properties.esign_type === 'stBoard' && propertyAvailable('esign_scrolling')">
                    <div class="col-md-12">
                        <Checkbox
                            class="mr-2"
                            :binary="true"
                            :modelValue="esign_scrolling_active"
                            :label="t_scrolling"
                            :disabled="element_readonly('esign_scrolling')"
                            @click="esign_scrolling_active = !esign_scrolling_active"
                        />
                        {{ t_scrolling }}
                    </div>
                    <div class="col-md-12" v-if="inner_properties.esign_scrolling > 0">
                        <number-field
                            v-model="inner_properties.esign_scrolling"
                            :label="t_scrolling_description"
                            :disabled="element_readonly('esign_scrolling')"
                            :limits="getFieldEvaluatedLimits('esign_scrolling')"
                            :outlined="outlined" :dense="dense" hide-details="auto">
                        </number-field>
                    </div>
                </div>
            </template>
        </template>

        <div class="row" v-if="propertyAvailable('scroll_speed')">
            <div class="col-md-12">
                <Checkbox
                    class="mr-2"
                    :binary="true"
                    :modelValue="scroll_speed_active"
                    :label="t_scrolling"
                    :disabled="element_readonly('scroll_speed')"
                    @click="scroll_speed_active = !scroll_speed_active"
                />
                {{ t_scrolling }}
            </div>
            <div class="col-md-12" v-if="inner_properties.scroll_speed > 0">
                <number-field
                    v-model="inner_properties.scroll_speed"
                    :label="t_scrolling_description"
                    :disabled="element_readonly('scroll_speed')"
                    :limits="getFieldEvaluatedLimits('scroll_speed')"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('rssfeed_url')">
            <div class="col-md-12">
                <v-text-field
                    v-model="active_text_fields.rssfeed_url"
                    :label="t_url"
                    :disabled="element_readonly('rssfeed_url')"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('rssfeed_url')"
                    v-on:blur="updateTextField('rssfeed_url')">
                </v-text-field>
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('separator')">
            <div class="col-md-6">
                <v-text-field
                    v-model="active_text_fields.separator"
                    :label="t_separator"
                    :disabled="element_readonly('separator') || inner_properties.no_spaces"
                    placeholder=" * "
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('separator')"
                    v-on:blur="updateTextField('separator')">
                </v-text-field>
            </div>
            <div class="col-md-12">
                <Checkbox
                    class="mr-2"
                    :binary="true"
                    :modelValue="inner_properties.no_spaces"
                    :label="t_no_spaces"
                    :disabled="element_readonly('no_spaces')"
                    @click="inner_properties.no_spaces = !inner_properties.no_spaces"
                />
                {{ t_no_spaces }}
            </div>
        </div>
        <div class="row" v-if="propertyAvailable('show_details')">
            <div class="col-md-12">
                <v-checkbox :label="t_show_details"
                            :disabled="element_readonly('show_details')"
                            v-model="inner_properties.show_details"
                            :outlined="outlined" :dense="dense" hide-details="auto">
                </v-checkbox>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('video_volume')">
            <div class="col-md-12">
                <div class="group-video-volume">
                    <number-field
                        v-model="inner_video_volume"
                        :label="t_video_volume"
                        :disabled="element_readonly('video_volume') || inner_properties.video_mute"
                        :append-icon="videoIcon"
                        @click:append="toggleVideoVolume()"
                        placeholder="100"
                        :limits="getFieldEvaluatedLimits('video_volume')"
                        :outlined="outlined" :dense="dense" hide-details="auto">
                    </number-field>
                </div>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('interval_automatic') || propertyAvailable('interval')">
            <div v-if="propertyAvailable('interval_automatic')" id="select-interval_automatic" :class="inner_properties.interval_automatic !== '1' ? 'col-md-6' : 'col-md-12'">
                <v-select
                    v-model="inner_properties.interval_automatic"
                    :label="t_interval_automatic"
                    :disabled="element_readonly('interval_automatic')"
                    :items="[
                        {value: '1', text: t_automatic},
                        {value: '0', text: t_manual}
                    ]"
                    attach="#select-interval_automatic .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
            <div :class="[propertyAvailable('interval_automatic') ? 'col-md-6' : 'col-md-12']" v-if="propertyAvailable('interval') && inner_properties.interval_automatic!=='1'">
                <number-field
                    v-model="inner_properties.interval"
                    :label="(
                        propertyAvailable('interval_automatic') ? t_interval_after : t_interval
                    ) + ' (' + t_seconds + ')'"
                    :disabled="element_readonly('interval')"
                    placeholder="11"
                    :limits="getFieldEvaluatedLimits('interval')"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('page_from') || propertyAvailable('page_to')">
            <div class="col-md-6" v-if="propertyAvailable('page_from')">
                <number-field
                    :value="pageFrom"
                    @input="val => handlePageUpdate('from', val)"
                    :label="t_page_from"
                    :disabled="element_readonly('page_from')"
                    placeholder="1"
                    :limits="getFieldEvaluatedLimits('page_from')"
                    :min="1"
                    :max="pageTo || inner_properties.page_count"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
            <div class="col-md-6" v-if="propertyAvailable('page_to')">
                <number-field
                    :value="pageTo"
                    @input="val => handlePageUpdate('to', val)"
                    :label="t_page_to"
                    :disabled="element_readonly('page_to')"
                    :placeholder="inner_properties.page_count"
                    :limits="getFieldLimits('page_to')"
                    :min="pageFrom || 1"
                    :max="inner_properties.page_count"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('city') || propertyAvailable('language')">
            <div :class="propertyAvailable('language') ? 'col-md-6' : 'col-md-12'" v-if="propertyAvailable('city')">
                <v-text-field
                    v-model="active_text_fields.city"
                    :label="t_city"
                    :disabled="element_readonly('city')"
                    :placeholder="t_depending_on_client"
                    @change="updateWeatherOrDay()"
                    :outlined="outlined" :dense="dense" hide-details="auto"
                    v-on:keydown="changedTextField('city')"
                    v-on:blur="updateTextField('city')">
                </v-text-field>
            </div>
            <div id="select-language" :class="propertyAvailable('city') ? 'col-md-6' : 'col-md-12'" v-if="propertyAvailable('language')">
                <v-autocomplete
                    v-model="inner_properties.language"
                    :label="t_language"
                    :disabled="element_readonly('language')"
                    :items="[
                            {value: 'de', text: 'Deutsch'},
                            {value: 'en', text: 'English'},
                            {value: 'fr', text: 'Français'},
                            {value: 'nl', text: 'Nederlands'},
                            {value: 'ru', text: 'Русский'}
                        ]"
                    @change="updateWeatherOrDay()"
                    attach="#select-language .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-autocomplete>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('rss_animation_type') || propertyAvailable('rss_speed')">
            <div id="select-rss_animation_type" class="col-md-6" v-if="propertyAvailable('rss_animation_type')">
                <v-select
                    v-model="inner_properties.text_animation_type"
                    :label="t_animation_type"
                    :disabled="element_readonly('rss_animation_type')"
                    :items="[
                            {value: 'none', text: t_animation_type_none},
                            {value: 'newsticker', text: t_animation_type_newsticker}
                        ]"
                    attach="#select-rss_animation_type .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
                </div>
                <div class="col-md-6" v-if="propertyAvailable('rss_speed')">
                    <number-field
                        v-model="inner_properties.text_speed"
                        :label="inner_properties.text_animation_type==='newsticker' ? t_newsticker_speed : t_switching_interval"
                        :disabled="element_readonly('rss_speed')"
                        placeholder="10"
                        :limits="getFieldLimits('rss_speed')"
                        :outlined="outlined" :dense="dense" hide-details="auto">
                    </number-field>
                </div>
            </div>

        <div class="row" v-if="propertyAvailable('rss_newsticker_space') && inner_properties.text_animation_type==='newsticker'">
            <div id="select-rss_newsticker_space" :class="inner_properties.text_newsticker_space==='custom_space' ? 'col-md-9' : 'col-md-12'" v-if="propertyAvailable('rss_newsticker_space')">
                <v-select
                    v-model="inner_properties.text_newsticker_space"
                    :label="t_newsticker_space"
                    :disabled="element_readonly('rss_newsticker_space')"
                    :items="[
                            {value: 'no_space', text: t_newsticker_space_none},
                            {value: 'custom_space', text: t_newsticker_space_custom},
                            {value: 'only_one_entry', text: t_newsticker_space_onlyone}
                        ]"
                    attach="#select-rss_newsticker_space .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
                </div>
                <div class="col-md-3" v-if="inner_properties.text_newsticker_space==='custom_space' && propertyAvailable('rss_newsticker_space_margin')">
                    <number-field
                        v-model="inner_properties.text_newsticker_space_margin"
                        :disabled="element_readonly('rss_newsticker_space_margin')"
                        placeholder="5"
                        :limits="getFieldLimits('rss_newsticker_space_margin')"
                        :outlined="outlined" :dense="dense" hide-details="auto">
                    </number-field>
                </div>
            </div>

        <div class="row" v-if="inner_properties.type != 'widget' && (propertyAvailable('stretch') || propertyAvailable('alignment'))">
            <div id="select-stretch" :class="inner_properties.stretch!=='frame' ? 'col-md-6' : 'col-md-12'" v-if="propertyAvailable('stretch')">
                <v-select
                    v-model="inner_properties.stretch"
                    :label="t_stretch"
                    :disabled="element_readonly('stretch')"
                    :items="[
                            {value: 'frame', text: t_stretch_frame},
                            {value: 'aspect_fit', text: t_stretch_aspect_fit},
                            {value: 'aspect_fill', text: t_stretch_aspect_fill},
                            {value: 'original', text: t_stretch_original},
                        ]"
                    attach="#select-stretch .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
            <div id="select-alignment" class="col-md-6" v-if="inner_properties.stretch!=='frame' && propertyAvailable('alignment')">
                <v-select
                    v-model="inner_properties.alignment"
                    :label="t_position"
                    :disabled="(inner_properties.stretch==='frame') || element_readonly('alignment')"
                    :items="[
                            {value: 'center', text: t_position_center},
                            {value: 'left top', text: t_position_topleft},
                            {value: 'right top', text: t_position_topright},
                            {value: 'right bottom', text: t_position_bottomright},
                            {value: 'left bottom', text: t_position_bottomleft},
                        ]"
                    attach="#select-alignment .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
        </div>

        <slot></slot>
    </div>
</template>

<script>
import commonDefinitionMixin from "./commonDefinitionMixin";
import elementTypes from "../elements/types";
import Checkbox from "../common/PrimeVue/Checkbox.vue";
import UrlLinkedFilesField from "./url-linked-files-field.vue";

export default {
    components: {Checkbox, UrlLinkedFilesField},
    mixins: [
        commonDefinitionMixin,
    ],
    props: [
        'value',
        'definition',
        'readonly',
        'advancedPrivilege',
        'basicPrivilege',
        'all_layer_layers',
        'parent_layers',
        'clearable',
        'esignConnectionDirect',
        'grid'
    ],
    data: function () {
        return {
            t_name: Lang.langGet("Name"),
            t_text: Lang.langGet("Text"),
            t_layer: Lang.langChoice("Layer|Layers", 1),
            t_backgroundcolor: Lang.langGet("Background Color"),
            t_rectanglecolor: Lang.langGet("Rectangle Color"),
            t_select: Lang.langGet("Select an option..."),
            t_time: Lang.langGet("Time"),
            t_url: Lang.langGet("URL"),
            t_user: Lang.langGet("Username"),
            t_iframe_user_explanation: Lang.langGet("Only works for basic authentication via HTTP"),
            t_pass: Lang.langGet("Password"),
            t_transparent: Lang.langGet("Transparent rendering"),
            t_loading_behavior: Lang.langGet("Loading behavior"),
            t_no_cache: Lang.langGet("Always load webpage without cache"),
            t_show_scrollbars: Lang.langGet("Show scrollbars"),
            t_wait_for_load: Lang.langGet("Wait for whole page to load before showing"),
            t_show_partial: Lang.langGet("Show partial pages (during download)"),
            t_wait_for_event: Lang.langGet("Wait for JS \"started\" event before showing"),
            t_renderer: Lang.langGet("Renderer"),
            t_windows_media_streaming: Lang.langGet("Windows-Media-Streaming"),
            t_quicktime: Lang.langGet("Quicktime"),
            t_no_spaces: Lang.langGet("No Separator"),
            t_show_details: Lang.langGet("Show Details"),
            t_separator: Lang.langGet("Separator"),
            t_video_mute: Lang.langGet("Mute"),
            t_video_volume: Lang.langGet("Volume in %"),
            t_interval: Lang.langGet("Next page after"),
            t_interval_after: Lang.langGet("after"),
            t_interval_automatic: Lang.langGet("Next page"),
            t_automatic: Lang.langGet("automatically"),
            t_manual: Lang.langGet("manually"),
            t_seconds: Lang.langChoice("Second|Seconds", 2),
            t_page_from: Lang.langGet("From page"),
            t_page_to: Lang.langGet("To page"),
            t_language: Lang.langChoice("Language|Languages", 1),
            t_city: Lang.langGet("City"),
            t_depending_on_client: Lang.langGet("Depending on Client"),
            t_animation_type: Lang.langGet("Animation Type"),
            t_animation_type_none: Lang.langGet("None"),
            t_animation_type_newsticker: Lang.langGet("Newsticker"),
            t_newsticker_speed: Lang.langGet("Newsticker Speed"),
            t_newsticker_space: Lang.langGet("Space between entries"),
            t_newsticker_space_none: Lang.langGet("No space between entries"),
            t_newsticker_space_custom: Lang.langGet("Custom space"),
            t_newsticker_space_onlyone: Lang.langGet("Always only one entry on screen"),
            t_newsticker_space_custom_margin: Lang.langGet("Margin"),
            t_switching_interval: Lang.langGet("Switching interval"),
            t_yes: Lang.langGet("Yes"),
            t_no: Lang.langGet("No"),
            t_date: Lang.langGet("Date"),
            t_youtube_playlist_explanation: Lang.langGet("Links to Youtube playlists don't work - use only direct video links."),
            t_esign_check: Lang.langGet("Checking eSign server..."),
            t_esign_type: Lang.langGet("eSign Type"),
            t_esign_board: Lang.langGet("Board"),
            t_esign_doorsign: Lang.langGet("Doorsign"),
            t_esign_id: Lang.langGet("ID"),
            t_esign_name: Lang.langGet("Name"),
            t_esign_style: Lang.langGet("Style"),
            t_esign_style_id: Lang.langGet("Style ID"),
            t_esign_refresh: Lang.langGet("Refresh"),
            t_esign_refresh_description: Lang.langGet("Gets refreshed every X seconds."),
            t_esign_transparency: Lang.langGet("Use Transparency"),
            t_scrolling: Lang.langGet("Activate Scrolling"),
            t_scrolling_description: Lang.langGet("seconds per page height"),
            t_position: Lang.langGet("Alignment"),
            t_position_center: Lang.langGet("Centered"),
            t_position_topleft: Lang.langGet("Top-Left"),
            t_position_topright: Lang.langGet("Top-Right"),
            t_position_bottomright: Lang.langGet("Bottom-Right"),
            t_position_bottomleft: Lang.langGet("Bottom-Left"),
            t_stretch: Lang.langGet("Stretch"),
            t_stretch_frame: Lang.langGet("Stretched to frame-size"),
            t_stretch_aspect_fill: Lang.langGet("Full-Frame with Aspect-Ratio"),
            t_stretch_aspect_fit: Lang.langGet("Stretched with Aspect-Ratio"),
            t_stretch_original: Lang.langGet("Original Size"),
            t_description: Lang.langGet("Description / Comment"),
            t_required: Lang.langGet("Required"),

            inner_properties: {},
            show: {iframe_pass: false},

            esign: {
                board_styles: [],
                boards: [],
                doorsign_styles: [],
                doorsigns: []
            },
            esign_manually: true,
            esign_check: false,

            rules: {
                required: value => !!value || this.t_required,
            },
            text_fields: ['name', 'text_input', 'url', 'iframe_url', 'iframe_user', 'iframe_pass', 'youtube_url',
                            'qrcode_url', 'esign_id', 'esign_name', 'esign_style', 'rssfeed_url', 'separator', 'city'],
            active_text_fields: [],
            timeout_id: null,
        }
    },
    computed: {
        pageFrom() {
            return this.getGuardedPageValue('from', this.inner_properties.page_from);
        },
        pageTo() {
            return this.getGuardedPageValue('to', this.inner_properties.page_to);
        },
        max_layer_parent: function () {
            if (this.parent_layers && this.parent_layers.length > 0) {
                return _.max(this.getLayerNr(this.parent_layers));
            }
            return -1;
        },
        esign_scrolling_active: {
            get: function () {
                return this.inner_properties.esign_scrolling > 0;
            },
            set: function () {
                this.toggleEsignScrolling();
            }
        },
        scroll_speed_active: {
            get: function () {
                return this.inner_properties.scroll_speed > 0;
            },
            set: function () {
                this.toggleScrollSpeed();
            }
        },
        inner_video_volume: {
            get: function () {
                return this.inner_properties.video_mute ? 0 : this.inner_properties.video_volume;
            },
            set: function (val) {
                if (!this.inner_properties.video_mute) {
                    this.inner_properties.video_volume = val;
                }
            }
        },
        inner_interval_automatic: {
            get: function () {
                return this.inner_properties.interval_automatic;
            },
            set: function (val) {
                if (this.inner_properties.interval_automatic !== val) {
                    Vue.set(this.inner_properties, 'interval_automatic', val);
                }
            }
        },
        dropzone_alternative_description: function () {
            if (this.grid === '3cols') {
                return Lang.langGet("Drag & Drop a Media-, Template-, or Campaign-Element below to change the alternative content:");
            } else {
                return Lang.langGet("Drag & Drop a Media-, Template-, or Campaign-Element on the right side to change the alternative content:");
            }
        },
        alternativeDropzoneStyles: function () {
            return {
                backgroundImage: "url('" + (this.inner_properties.alternative_background_image??"") + "')",
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                marginTop: '12px',
                marginBottom: '12px'
            }
        },
        alternativeContentSet: function () {
            return (this.inner_properties.alternative_type && this.inner_properties.alternative_type !== "");
        },
        alternativeDropzoneInfo: function () {
            return this.alternativeContentSet ?
                (Lang.langGet(elementTypes.titles[this.inner_properties.alternative_type]) + ': ' + this.inner_properties.alternative_name) : null;
        },
        selectableLayers: function () {
            let layers = [];//{value: '', text: this.t_select}];
            _.each(this.all_layer_layers, (layer) => {
                if (this.is_selectable_layer(layer.value) === true) {
                    let layer_ = {value: layer.value, text: layer.text};
                    layers.push(layer_);
                }
            });
            return layers;
        },
        videoIcon: function () {
            if (this.inner_properties.video_mute || this.inner_properties.video_volume === 0) {
                return  'fa-regular fa-volume-off fa-fw';
            } else if (this.inner_properties.video_volume > 50 || this.inner_properties.video_volume === '') {
                return 'fa-regular fa-volume-up fa-fw';
            } else {
                return 'fa-regular fa-volume-down fa-fw';
            }
        }
    },
    watch: {
        value: function () {
            this.inner_properties = this.value;
            this.active_text_fields = [];

            _.forEach(this.text_fields, (field) => {
                if (this.propertyAvailable(field)) {
                    this.active_text_fields[field] = this.inner_properties[field];
                }
            })
        },
    },
    methods: {
        handlePageUpdate(prop, value) {
            this.inner_properties['page_' + prop] = this.getGuardedPageValue(prop, +(value));
        },
        getGuardedPageValue(prop, value) {
            if (prop === 'to') {
                if (value > this.inner_properties.page_count) {
                    return this.inner_properties.page_count;
                } else if (value < this.inner_properties.page_from) {
                    return this.inner_properties.page_from;
                }
                return value;
            }

            if (prop === 'from') {
                if (value <= 0) {
                    return 1;
                } else if (value > this.inner_properties.page_to) {
                    return this.inner_properties.page_to;
                }
                return value;
            }
        },
        resetAlternativeContent: function () {
            this.inner_properties.alternative_type = "";
            this.inner_properties.alternative_name = "";
            this.inner_properties.alternative_background_image = "";
            this.inner_properties.alternative_id = "";
        },
        elementProperties: function () {
            return this.definition;
        },
        toggleEsignScrolling: function () {
            if (!this.element_readonly('esign_scrolling')) {
                if (this.inner_properties.esign_scrolling > 0) {
                    this.inner_properties.esign_scrolling = 0;
                } else {
                    this.inner_properties.esign_scrolling = 15;
                }
            }
        },
        toggleScrollSpeed: function () {
            if (!this.element_readonly('scroll_speed')) {
                if (this.inner_properties.scroll_speed > 0) {
                    Vue.set(this.inner_properties, 'scroll_speed', 0);
                } else {
                    Vue.set(this.inner_properties, 'scroll_speed', 15);
                }
            }
        },
        toggleVideoVolume: function () {
            if (!this.element_readonly('video_mute')) {
                Vue.set(this.inner_properties, 'video_mute', !this.inner_properties.video_mute);
            }
        },
        setEsignName: function () {
            let spec = null;
            if (this.inner_properties.esign_type === 'stBoard') {
                spec = this.esign.boards.find((board) => { return board.id === this.inner_properties.esign_id });
            } else {
                spec = this.esign.doorsigns.find((doorsign) => { return doorsign.id === this.inner_properties.esign_id });
            }
            if (spec) {
                this.inner_properties.name = spec.name;
            } else {
                this.inner_properties.name = '';
            }
        },
        is_selectable_layer: function (id) {
            let layer = this.getLayerNr([String(id)])[0];
            return layer > this.max_layer_parent || this.max_layer_parent === -1;
        },
        updateWeatherOrDay: function () {
            this.$nextTick(() => {
                if (this.inner_properties.type === 'weather') {
                    EaseEventBus.fire('updateWeather');
                } else if (this.inner_properties.type === 'day') {
                    EaseEventBus.fire('updateDay');
                }
            })
        },
        updateEsignName: function (type) {
            var data = [];
            if(type === 'boards') {
                data = this.esign.boards;
            } else if (type === 'doorsigns') {
                data = this.esign.doorsigns;
            }
            data.every((item) => {
                if (item.id === this.inner_properties.esign_id) {
                    this.inner_properties.esign_name = item.name;
                    return false;
                }
                return true;
            });
        },
        removeAttachedFile: function (file, index) {
            // console.log('remove file', file, index);
            this.inner_properties.linked_files.splice(index, 1);
        },
        changedTextField: function (field) {
            clearTimeout(this.timeout_id);
            this.timeout_id = setTimeout(this.updateTextField, 1000, field);
        },
        updateTextField: function (field_type) {
            clearTimeout(this.timeout_id);
            this.inner_properties[field_type] = this.active_text_fields[field_type];
        }
    },
    mounted: function () {
        this.inner_properties = this.value;

        if (this.esignConnectionDirect === '1') {
            this.esign_manually = false;
        }
        this.esign_check = true;
        axios.get('/esign/' + Laravel.activeProject).then((response) => {
            if (response.data.doorsigns.length === 0 && response.data.boards.length === 0) {
                this.esign_manually = true;
            } else {
                this.esign = _.assign({}, this.esign, response.data);
            }

            this.esign_check = false;
        }).catch((error) => {
            if (error.response.status === 401) {
                window.location = '/login';
            } else {
                this.esign_manually = true;
                this.esign_check = false;
            }
        });
    }
}
</script>
